module.exports = __webpack_public_path__ + "img/mktBI-Web-App-4-min.69ac53e9.png";